(() => {
  function setup(root) {
    const home = root.matches?.('.sy-home') ? root : root.querySelector?.('.sy-home');
    if (!home || home.dataset.ready) return;
    home.dataset.ready = 'true';
    const media = window.matchMedia('(max-width: 800px)');
    const sync = () => home.querySelectorAll('.sy-footer-links').forEach(el => { el.open = !media.matches; });
    sync();
    media.addEventListener('change', sync);
    const menu = home.querySelector('.sy-mobile-menu');
    menu?.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    home.addEventListener('click', event => { if (menu?.open && !menu.contains(event.target)) menu.open = false; });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
